/* eslint-disable */
(() => {
  function getCookie(e) {
    const n = e + '=';
    const t = document.cookie.split(';');
    for (let e = 0; e < t.length; e++) {
      let a = t[e];
      for (; ' ' === a.charAt(0); ) a = a.substring(1, a.length);
      if (0 === a.indexOf(n)) {
        try {
          return JSON.parse(decodeURIComponent(a.substring(n.length, a.length)));
        } catch (err) {
          return {};
        }
      }
    }
    return {};
  }
  const consentData = getCookie('avada_cookie_consent');
  const {microsoftConsentMode = {enabled: true}, shouldShowBanner = true} = getCookie('integration');

  if (!microsoftConsentMode.enabled) return;

  if (!consentData.hasOwnProperty('marketing')) {
    consentData.marketing = !shouldShowBanner;
  }

  window.uetq = window.uetq || [];
  window.uetq.push('consent', 'default', {
    "ad_storage": consentData.marketing ? 'granted': 'denied'
  })
  if (window.clarity) {
    window.clarity('consent', consentData.marketing);
  }
})()
